/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/VideoPlaylist/theme';

export const VideoPlaylistTheme = theme;
